import { render, staticRenderFns } from "./PromotionCollections.vue?vue&type=template&id=76fbe2d6"
import script from "./PromotionCollections.vue?vue&type=script&lang=js"
export * from "./PromotionCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports